<template>
  <div :class="site" id="app">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "@/templates/Header";
// import Main from "@/templates/Main";
import Footer from "@/templates/Footer";
export default {
  name: "app",
  data: function () {
    return {
      site: window.location.host.split(".")[1] || "lelis"
    };
  },
  components: {
    Header,
    // Main,
    Footer,
  },
   methods: {
    changeFavicon() {
     const FAVICONS = {
        johnjohndenim : "/johnjohn.png",
        bobo: "/bobo.png",
        lelis: "/lelis.png",
        dudalina: "/dudalina.ico",
        rosacha: "/rosacha.ico",
        estoque: "/estoque.png"
      }
      let icon = document.getElementById('favicon');
      icon.href = `${FAVICONS[window.location.hostname.split('.')[1]]}`;
    }
  },
  created() {
    this.changeFavicon();
  }
};
</script>

<style lang="scss">
@import "./assets/styles/variables";
@import "./assets/styles/bootstrap";

/* FONT IMPORTS */

/* dudalina || johnjohndenim || estoque || lelis*/
@import url("https://fonts.googleapis.com/css?family=Heebo:400,500,700|Lato:300,400,700,900|Roboto:300,400,700&display=swap");
/* bobo */
@font-face {
  font-family: "Bodoni Book";
  src: url("./assets/fonts/bodoni_book.otf");
}
/* rosacha */
@font-face {
  font-family: "Orator Std";
  src: url("./assets/fonts/orator_std.otf");
}

body {
  margin: 0;
  line-height: 1.5;
  & .dudalina {
    font-family: "Roboto";
    background-color: #f6f6f6;
    & header {
      & a {
        text-decoration: none;
        color: #fff;
      }
      & .menu a img:hover {
        margin-bottom: -2px;
        border-bottom: 2px solid #fff;
      }
      & .header-links {
        background-color: #000;
        & div a span:hover {
          border-bottom: 4px solid #fff;
        }
        & div a {
          color: #fff;
        }
      }
      & .help-center h4 {
        font-size: 15px;
        font-weight: 700;
        color: #fff;
      }
    }
    & .search-section h1 {
      font-weight: 700;
    }
    & footer {
      & .footer-inner {
        & .footer-links {
          & div h4 {
            font-weight: 400;
          }
        }
      }
      & .copyright {
        background-color: #fff;
        margin: 0 auto;
        font-weight: 400;
        color: #999;
        font-size: 11px;
      }
    }
    .new-request-section {
      & div {
        & button {
          font-weight: 700;
        }
      }
    }
    & main {
      & .articles-list {
        & li {
          & a {
            font-size: 12px;
          }
        }
      }
      & .categories-list {
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      &.active {
        & a {
          & * {
            background-color: #000;
          }
        }
      }
    }
  }
  & .johnjohndenim {
    font-family: "Lato";
    background-color: #fff;
    & header {
      background-color: #fff;
      color: #000;
      & .header-content {
        background-color: #fff;
      }
      & a {
        text-decoration: none;
        color: #fff;
        font-weight: 900;
      }
      & .menu a img:hover {
        margin-bottom: -2px;
        border-bottom: 2px solid #000;
      }
      & .header-links {
        background-color: #000;
        & div a span:hover {
          border-bottom: 4px solid #fff;
        }
        & div a {
          color: #fff;
        }
      }
      & .help-center h4 {
        font-weight: 13px;
        font-weight: 900;
        color: #808080;
      }
    }
    & .block-item {
      border: 1px solid #000;
    }
    & .search-section h1 {
      font-weight: 900;
    }
    & .search-div {
      & input {
        border-bottom: 1px solid #000;
      }
    }
    & footer {
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;
      & .footer-inner {
        & .footer-links {
          & div h4 {
            font-weight: 900;
          }
        }
      }
      & .seals {
        padding-bottom: 24px
      }
      & .copyright {
        border-top: 1px solid rgba(0, 0, 0, 1);
        font-weight: 900;
        color: rgba(0, 0, 0, 1);
        font-size: 11px;
      }
    }
    .new-request-section {
      & div {
        & button {
          font-weight: 900;
        }
      }
    }
    & main {
      & .articles-list {
        & li {
          border: 1px solid #000;
          margin: 0;
          border-bottom: 0px;
          & a {
            font-size: 12px;
          }
        }
        & li:last-child {
          border-bottom: 1px solid #000;
        }
      }
      & .categories-list {
        & div {
          & a {
            border: 1px solid #000;
          }
        }
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      &.active {
        & a {
          & * {
            background-color: #000;
          }
        }
      }
    }
  }
  & .estoque {
    font-family: "Heebo";
    & header {
      & .header-content {
        background-color: #fff;
      }
      color: #fff;
      & a {
        text-decoration: none;
        color: #fff;
        font-weight: 400;
      }
      & .header-links {
        background-color: #000;
        & ul {
          & li {
            height: 55px;
            align-items: center;
            justify-content: center;
            display: flex;
            transition: all 300ms ease;
            margin: 0 20px;
            & span {
              font-weight: 500;
              font-size: 15px;
            }
          }
          & div a {
            color: #fff;
          }
        }
      }
      & .help-center h4 {
        font-weight: 13px;
        font-weight: 500;
        color: #808080;
      }
    }

    & .search-section h1 {
      font-weight: 500;
    }
    & .search-div {
      & input {
        font-size: 15px;
        color: #999;
        transition: 100ms ease;
        background-color: #f2f2f2;
      }
    }
    & footer {
      background-color: #f2f2f2;
      & .footer-inner {
        & .footer-links {
          & h4 {
            color: #808080;
            font-weight: 500;
          }
          & li a {
            color: #000;
            font-weight: 400;
          }
        }
      }
      & .seals {
        display: none !important;
      }
      & .copyright {
        color: #808080;
        font-size: 12px;
        text-align: center;
        border-top: 1px solid #ccc;
        text-align: initial;
      }
    }
    .new-request-section {
      & button {
        font-weight: 500;
      }
      & span,
      p {
        color: #808080;
        font-size: 12px;
        & a {
          font-weight: 700;
        }
      }
    }
    & main {
      background-color: #fff;
      & .articles-list {
        & li {
          border: 1px solid #ccc;
          & a {
            font-size: 12px;
          }
        }
      }
      & .article-title {
        font-weight: 900;
      }
      & .categories-list {
        & a {
          border: 1px solid #ccc;
        }
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      & .block-item {
        border: 1px solid #ccc;
      }
    }
  }
  & .bobo {
    font-family: "Roboto";
    background-color: #f6f6f6;
    & header {
    & .header{
      background-color: #ffffff;
      padding: 0;
    }
      & .header-content {
        font-family: "Lato", sans-serif;
        background-color: #ffffff;
      }
      
      & .hero{
        background-position: center;
      }
      color: #fff;
      & a {
        text-decoration: none;
        color: #fff;
        font-weight: 400;
      }
      & .header-links {
        font-family: "Lato", sans-serif;
        background-color: #fff;
        border-top: 1px solid #ddd;
        & ul {
          & li {
            height: 55px;
            align-items: center;
            justify-content: center;
            display: flex;
            transition: all 300ms ease;
            margin: 0 20px;
            & a {
              color: #000;
              & span {
                border-bottom: 2px solid transparent;
                white-space: nowrap;
              }
              &:hover span {
                border-bottom: 2px solid #bead85;
              }
            }
          }
        }
      }
      & .help-center h4 {
        font-weight: 400;
        color: #000;
      }
    }
    & .search-section h1 {
      font-weight: 400;
      font-family: "Lato", sans-serif;
    }
    & .search-div {
      & input {
        font-family: "Roboto";
        font-size: 15px;
        color: #999;
        transition: 100ms ease;
      }
    }
    & footer {
      font-family: "Lato", sans-serif;
      background-color: #fff;
      & .footer-inner {
        & .footer-links {
          & div h4,
          div li,
          div li a {
            color: #000;
            font-weight: 400;
          }
          & div h4 {
            font-weight: 700;
          }
          .social-networks {
            img {
              max-height: 20px;
            }
            &~img{
              filter: brightness(0);
            }
          }
        }
      }
      & .seals {
        padding-bottom: 24px
      }
      & .copyright {
        background-color: #f6f6f6;
        color: #999;
        font-size: 12px;
        text-align: center;
      }
    }
    .new-request-section {
      & button {
        font-weight: 400;
      }
      & span,
      p {
        color: #000;
        font-size: 12px;
        & a {
          font-weight: 700;
        }
      }
    }
    & main {
      & .articles-list {
        & li {
          & a {
            font-size: 12px;
          }
        }
      }
      & .article-title {
        font-weight: 900;
      }
      & .categories-list {
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      &.active {
        & a {
          & * {
            background-color: #000;
          }
        }
      }
    }
  }
  & .rosacha {
    font-family: "Orator Std";
    background-color: #f6f6f6;
    & header {
      & .header-content {
        background-color: #fff;
      }
      color: #000;
      & a {
        text-decoration: none;
        color: #fff;
        font-weight: 400;
      }
      & .menu a img {
        transition: all 300ms ease;
        &:hover {
          filter: brightness(1) invert(1);
        }
      }
      & .header-links {
        background-color: #000;
        & ul {
          & div li {
            height: 55px;
            align-items: center;
            justify-content: center;
            display: flex;
            transition: all 300ms ease;
            margin: 0 20px;
            &:hover {
              background-color: #fff;
              & a span {
                color: #000;
              }
            }
          }
          & div a {
            color: #fff;
          }
        }
      }
      & .help-center h4 {
        font-weight: 13px;
        font-weight: 400;
        color: rgb(0, 0, 0);
      }
    }

    & .search-section h1 {
      font-weight: 400;
    }
    & .search-div {
      & input {
        font-family: "Orator Std";
        font-size: 15px;
        color: #999;
      }
    }
    & footer {
      background-color: #626262;
      & .footer-inner {
        & .footer-links {
          & div h4,
          div li,
          div li a {
            color: #fff;
            font-weight: 400;
            font-family: "Orator Std";
          }
        }
      }
      & .copyright {
        background-color: #fff;
        color: #999;
        font-size: 12px;
        text-align: center;
      }
    }
    .new-request-section {
      & button {
        font-weight: 400;
      }
      & span,
      p {
        color: #000;
        font-size: 12px;
        & a {
          font-weight: 700;
        }
      }
    }
    & main {
      & .articles-list {
        & li {
          & a {
            font-size: 12px;
          }
        }
      }
      & .article-title {
        font-weight: 900;
      }
      & .categories-list {
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      &.active {
        & a {
          & * {
            background-color: #000;
          }
        }
      }
    }
  }
  & .lelis {
    font-family: "Lato";
    background-color: #fff;
    & header {
      & .header {
        background-color: #fff;
      }
      color: #fff;
      & .homepage-logo img{
        width: 130px;
      }
      & .header-content {
        background-color: #FFF;
      }
      & .hero{
        background-position: center;
      }
      & .header-links {
        background-color: #fff;
        border-top: 1px solid #ccc;
        & ul {
          & li:hover {
            margin-bottom: -4px;
            border-bottom: 4px solid #000;
            a {
              text-decoration: none;
              color: #000;
            }
          }
          & li {
            & a {
              color: #000;
              text-decoration: none;
              & span {
                margin: 0 20px;
                color: inherit;
              }
            }
          }
        }
      }

      @media (max-width: 767px) {
        .header-links {
          & ul {
            & li {
              & a {
                & span {
                  margin: 0;
                }
              }
            }
          }
        }
      }

      & .help-center h4 {
        font-weight: 13px;
        font-weight: 400;
        color: #000;
      }
      .menu {
        img {
          filter: invert(0);
        }
      }
    }
    & .block-item {
      border: 1px solid #707070;
      & a:hover {
        color: #000;
        font-weight: 700;
      }
    }
    & .search-section h1 {
      font-size: 24px;
      font-weight: 400;
      margin: 0 0 24px;
    }
    & .search-div {
      & input {
        border: 1px solid #000;
      }
    }
    & footer {
      background-color: #FBFBFB;
      & .footer-inner {
        & .footer-links {
          & a {
            font-weight: 300 !important;
          }
          & div h4 {
            color: #000;
            font-weight: 700;
            font-family: "Lato";
          }
          .social-networks {
            img {
              max-height: 20px;
            }
            &~img{
              filter: brightness(0);
            }
          }
        }
      }
      & .copyright {
        background-color: #FFF;
        font-weight: 400;
        color: #666;
        font-size: 11px;
      }
    }
    .new-request-section {
      font-family: "Lato";
      font-weight: 400;
      & button {
        font-weight: 700;
      }
      & span,
      p {
        color: #999;
        font-size: 12px;
        & a {
          color: #000;
          font-weight: 700;
        }
      }
    }
    & main {
      & .articles-list {
        & li {
          border: 1px solid #000;
          margin: 0;
          border-bottom: 0px;
          & a {
            font-size: 12px;
          }
        }
        & li:last-child {
          border-bottom: 1px solid #000;
        }
      }
      & .article-title {
        font-weight: 900;
      }
      & .categories-list {
        & div {
          & a {
            border: 1px solid #000;
          }
        }
        & .active {
          & a {
            background-color: #000;
            color: #fff;
            & img {
              filter: brightness(0) invert(1);
            }
          }
        }
      }
      &.active {
        & a {
          & * {
            background-color: #000;
          }
        }
      }
    }
  }
}
</style>
